import { render } from "./trumpetTemplate.vue?vue&type=template&id=0fb60c45&scoped=true"
import script from "./trumpetTemplate.vue?vue&type=script&lang=js"
export * from "./trumpetTemplate.vue?vue&type=script&lang=js"

import "./trumpetTemplate.vue?vue&type=style&index=0&id=0fb60c45&scoped=true&lang=css"
import "./trumpetTemplate.vue?vue&type=style&index=1&id=0fb60c45&lang=css"
script.render = render
script.__scopeId = "data-v-0fb60c45"

export default script